export default __webpack_public_path__ + "static/media/upload_file_icon.37ce9649.svg";